export const images = {
  hero: '/images/brand/eva01.jpeg',
  about: '/images/brand/eva02.jpeg',
} as const;
